import styled from "styled-components";

export const Div = styled.div`
    p {
        margin-bottom: 0.7rem;
    }

    h3 {
        color: rgba(14, 45, 71, 1);
        font-size: 1rem;
        margin: 1.25rem 0 1rem;
    }
`;


// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/faq_component/styles.jsx